import React from "react";

import { defineMessages, useIntl } from "react-intl";

import CardCta from "@app/component/DashCard/CardCta";
import configService from "@app/config/ConfigService";
import authService from "@app/store/auth/AuthService";
import { getLegacyAppUrl } from "@app/util/appUrl";

import styles from "./EmptyRecordsStats.module.scss";

const messages = defineMessages({
  assignCadences: {
    id: "home.cards.engagement.emptyRecordsStats.assignCadences",
    defaultMessage: "Set frequencies on groups to get reminders to follow up",
    description: "",
  },
  learnMore: {
    id: "home.cards.engagement.emptyRecordsStats.learnMore",
    defaultMessage: "Learn more about frequencies",
    description: "",
  },
  manageGroups: {
    id: "home.cards.engagement.emptyRecordsStats.manageGroups",
    defaultMessage: "Manage groups",
    description: "",
  },
  noRecords: {
    id: "home.cards.engagement.emptyRecordsStats.noRecords",
    defaultMessage: "No records past due",
    description: "",
  },
});

const CADENCE_ARTICLE_URL =
  "https://support.mapmycustomers.com/hc/en-us/articles/360047068794-Cadence";

const EmptyRecordsStats: React.FC = () => {
  const intl = useIntl();

  const token = authService.getToken();

  if (!token) {
    return null;
  }

  const manageGroupsHref = getLegacyAppUrl(
    configService.getBaseOldAppUrl(),
    token,
    "/accounts/groups/list"
  );

  return (
    <CardCta
      buttonLabel={intl.formatMessage(messages.manageGroups)}
      href={manageGroupsHref}
      text={
        <>
          <p>{intl.formatMessage(messages.noRecords)}</p>
          <p className={styles.instructions}>{intl.formatMessage(messages.assignCadences)}</p>
        </>
      }
    >
      <a href={CADENCE_ARTICLE_URL} rel="noopener noreferrer" target="_blank">
        {intl.formatMessage(messages.learnMore)}
      </a>
    </CardCta>
  );
};

export default EmptyRecordsStats;
